export enum AuthEvents {
  Login = 'Login',
  Onboard = 'Onboard',
  LogOut = 'LogOut',
  VatAttempt = 'VatAttempt',
}
